module.exports = __webpack_public_path__ + "img/instagram.012ba595.jpg";